// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Spinner/Loading Animation */
.spinner {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 10px;
    border: 3px solid rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    border-top-color: #3498db;
    animation: spinner 1s ease-in-out infinite;
    vertical-align: middle;
  }
  
@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}
    
/* Style for analysis running status */
.analysis-running {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
  padding: 15px;
  background-color: #e8f4fd;
  border-radius: 8px;
  color: #2980b9;
  font-weight: 500;
  font-size: 18px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}
  
.analysis-running .spinner {
  width: 24px;
  height: 24px;
  border-width: 4px;
}`, "",{"version":3,"sources":["webpack://./src/css/spinner.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,kBAAkB;IAClB,yBAAyB;IACzB,0CAA0C;IAC1C,sBAAsB;EACxB;;AAEF;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":["/* Spinner/Loading Animation */\n.spinner {\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    margin-right: 10px;\n    border: 3px solid rgba(0, 0, 0, 0.1);\n    border-radius: 50%;\n    border-top-color: #3498db;\n    animation: spinner 1s ease-in-out infinite;\n    vertical-align: middle;\n  }\n  \n@keyframes spinner {\n  to {\n    transform: rotate(360deg);\n  }\n}\n    \n/* Style for analysis running status */\n.analysis-running {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 20px 0;\n  padding: 15px;\n  background-color: #e8f4fd;\n  border-radius: 8px;\n  color: #2980b9;\n  font-weight: 500;\n  font-size: 18px;\n  box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n}\n  \n.analysis-running .spinner {\n  width: 24px;\n  height: 24px;\n  border-width: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
